/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_EmptyInputs */

const en_settings_tickets_empty = /** @type {(inputs: Settings_Tickets_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tickets yet`)
};

const zh_settings_tickets_empty = /** @type {(inputs: Settings_Tickets_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无工单`)
};

/**
* | output |
* | --- |
* | "No tickets yet" |
*
* @param {Settings_Tickets_EmptyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_tickets_empty = /** @type {((inputs?: Settings_Tickets_EmptyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_EmptyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_tickets_empty(inputs)
	return zh_settings_tickets_empty(inputs)
});
export { settings_tickets_empty as "settings.tickets.empty" }